import OktaAuth from '@okta/okta-auth-js';

const issuer = import.meta.env.VITE_OKTA_ISSUER;
const clientId = import.meta.env.VITE_OKTA_CLIENT_ID;

if (!issuer || !clientId) {
  console.warn(
    '[Okta] Set OKTA_ISSUER and OKTA_CLIENT_ID in repo-root .env.local (surfaced as VITE_OKTA_* via Vite).'
  );
}

/** Standard OIDC scopes only — avoids “scopes not configured” unless you add custom scopes in Okta + env. */
const baseScopes = ['openid', 'profile', 'email'] as const;
const extraScopes = (import.meta.env.VITE_OKTA_EXTRA_SCOPES ?? '')
  .split(',')
  .map((s) => s.trim())
  .filter(Boolean);

export const oktaAuth = new OktaAuth({
  issuer: issuer || 'https://placeholder.invalid',
  clientId: clientId || 'placeholder',
  redirectUri: `${window.location.origin}/login/callback`,
  postLogoutRedirectUri: `${window.location.origin}/`,
  scopes: [...baseScopes, ...extraScopes],
  pkce: true,
  tokenManager: { autoRenew: true, storage: 'sessionStorage' },
});
